import { Model, Service } from ".";

export default class ServiceType extends Model {
	get singularNoun() {
		return "service type";
	}

	get mutations() {
		return {
			services: Service
		};
	}

	resource() {
		return "service-types";
	}
}
